exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".frame[data-v-4d66f45a]{margin:20px;padding:20px}.link[data-v-4d66f45a]{text-decoration:none}.link h1[data-v-4d66f45a]{color:#000;font-weight:200;font-size:14pt}", ""]);

